import type { ApiRentalDealItem, ApiCreateRentalDealPayload } from 'src/types/rental';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from 'src/utils/axios';

import { QueryKeys } from './QueryKeys';

/**
 * Creates a rental deal — DB record only (rental-clock v2.1, deploy-on-Pay): the
 * escrow contract is deployed by usePrepareRentalPayment when the renter proceeds
 * to pay. The renter is derived from the authenticated wallet; the body carries
 * the booking window + pickup mode. rentalContractState stays null until then.
 */
export function useCreateRentalDeal() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ listingId, ...body }: ApiCreateRentalDealPayload) => {
      const response = await axios.post<ApiRentalDealItem>(
        `/buyer/rentals/${listingId}/deal`,
        body
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.rentalDeals() });
    },
  });
}
